(function () {
  var EMAIL_STORAGE_KEY = 'hm_account_email';
  var RETURN_TO_STORAGE_KEY = 'hm_account_return_to';

  function persistEmailForFlow(email) {
    try {
      window.sessionStorage.setItem(EMAIL_STORAGE_KEY, email);
    } catch (e) {
      // Ignore storage failures (privacy mode, blocked storage, etc.)
    }
  }

  function getPersistedEmail() {
    try {
      return normalizeEmail(window.sessionStorage.getItem(EMAIL_STORAGE_KEY));
    } catch (e) {
      return '';
    }
  }

  function normalizeReturnTo(value) {
    var normalized = (value || '').trim();

    if (!normalized) {
      return '';
    }

    if (normalized.charAt(0) !== '/' || normalized.indexOf('//') === 0) {
      return '';
    }

    return normalized;
  }

  function persistReturnToForFlow(returnTo) {
    var normalized = normalizeReturnTo(returnTo);

    if (!normalized) {
      return '';
    }

    try {
      window.sessionStorage.setItem(RETURN_TO_STORAGE_KEY, normalized);
    } catch (e) {
      // Ignore storage failures (privacy mode, blocked storage, etc.)
    }

    return normalized;
  }

  function getPersistedReturnTo() {
    try {
      return normalizeReturnTo(window.sessionStorage.getItem(RETURN_TO_STORAGE_KEY));
    } catch (e) {
      return '';
    }
  }

  function resolveReturnTo() {
    var queryValue = normalizeReturnTo(new URLSearchParams(window.location.search).get('return_to'));

    if (queryValue) {
      return persistReturnToForFlow(queryValue);
    }

    return getPersistedReturnTo();
  }

  function resolvePostCompletionRedirect(fallbackUrl) {
    var returnTo = resolveReturnTo();

    // トップへの戻りはマイページへ誘導する（人マークからのログイン完了時など）。
    if (returnTo === '/') {
      returnTo = '';
    }

    return returnTo || normalizeReturnTo(fallbackUrl) || '/';
  }

  function setFieldError(form, fieldName, message) {
    var errorEl = form.querySelector('[data-field-error="' + fieldName + '"]');

    if (!errorEl) {
      return;
    }

    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function setFormStatus(form, type, message) {
    var successEl = form.querySelector('[data-form-status="success"]');
    var errorEl = form.querySelector('[data-form-status="error"]');

    if (successEl) {
      successEl.hidden = true;
      successEl.textContent = '';
    }

    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    if (!message) {
      return;
    }

    var target = type === 'success' ? successEl : errorEl;

    if (target) {
      target.hidden = false;
      target.textContent = message;
    }
  }

  function validate(form, i18n) {
    var lastName = (form.elements.lastName.value || '').trim();
    var firstName = (form.elements.firstName.value || '').trim();
    var birthDate = form.elements.birthDate.value || '';
    var gender = form.elements.gender.value || '';
    var hasError = false;

    setFieldError(form, 'lastName', '');
    setFieldError(form, 'firstName', '');
    setFieldError(form, 'birthDate', '');
    setFieldError(form, 'gender', '');
    setFormStatus(form, 'error', '');

    if (!lastName) {
      setFieldError(form, 'lastName', i18n.required);
      hasError = true;
    }

    if (!firstName) {
      setFieldError(form, 'firstName', i18n.required);
      hasError = true;
    }

    if (!birthDate) {
      setFieldError(form, 'birthDate', i18n.required);
      hasError = true;
    } else {
      var selectedDate = new Date(birthDate + 'T00:00:00');
      var now = new Date();
      now.setHours(0, 0, 0, 0);

      if (selectedDate > now) {
        setFieldError(form, 'birthDate', i18n.birthDateInvalid);
        hasError = true;
      }
    }

    if (!gender) {
      setFieldError(form, 'gender', i18n.required);
      hasError = true;
    }

    return !hasError;
  }

  function toggleSubmitting(form, isSubmitting, i18n) {
    var submitButton = form.querySelector('[data-submit-button]');

    if (!submitButton) {
      return;
    }

    // ログイン済み（更新）か未ログイン（作成）かでボタン文言を出し分ける。
    var isLoggedIn = form.getAttribute('data-customer-logged-in') === 'true';
    var idleLabel = isLoggedIn ? (i18n.update || i18n.submit) : i18n.submit;
    var busyLabel = isLoggedIn ? (i18n.updating || i18n.submitting) : i18n.submitting;

    submitButton.disabled = isSubmitting;
    submitButton.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    submitButton.textContent = isSubmitting ? busyLabel : idleLabel;
  }

  function normalizeEmail(value) {
    return (value || '').trim().toLowerCase();
  }

  function getEmailFromQuery() {
    return normalizeEmail(new URLSearchParams(window.location.search).get('email'));
  }

  function getEmailFromCustomer(form) {
    return normalizeEmail(form.getAttribute('data-customer-email') || '');
  }

  function resolveInitialEmail(form) {
    return getEmailFromQuery() || getPersistedEmail() || getEmailFromCustomer(form);
  }

  function resolveLoginOrigin(shopOrigin) {
    var hostname = window.location.hostname;
    if (hostname === '127.0.0.1' || hostname === 'localhost') {
      return shopOrigin || window.location.origin;
    }

    return window.location.origin;
  }

  function buildLoginRedirectUrl(targetUrl, email, shopOrigin, returnTo) {
    var url = new URL(targetUrl, resolveLoginOrigin(shopOrigin));
    if (email) {
      url.searchParams.set('login_hint', email);
    }
    url.searchParams.set('login_hint_mode', 'submit');
    url.searchParams.delete('return_url');

    var normalizedReturnTo = normalizeReturnTo(returnTo);
    if (normalizedReturnTo) {
      url.searchParams.set('return_to', normalizedReturnTo);
    }

    return url.toString();
  }

  function setupLeaveGuard(form) {
    var guard = { allowLeave: false };

    window.addEventListener('beforeunload', function (event) {
      if (guard.allowLeave) {
        return;
      }

      event.preventDefault();
      event.returnValue = '';
    });

    var card = form.closest('.profile-completion-card');
    var backLink = card ? card.querySelector('.profile-completion-back-link--top') : null;

    if (backLink) {
      backLink.addEventListener('click', function (event) {
        if (guard.allowLeave) {
          return;
        }

        event.preventDefault();
        window.location.href = backLink.href;
      });
    }

    return guard;
  }

  function setProfileStatusLoading(form, isLoading, hideShell) {
    form.dataset.profileStatusLoading = isLoading ? 'true' : 'false';

    if (!hideShell) {
      return;
    }

    var shell = form.closest('.profile-completion-shell');

    if (shell) {
      shell.classList.toggle('is-profile-status-loading', isLoading);
    }
  }

  function applyProfileToForm(form, profile) {
    if (!profile) {
      return;
    }

    if (profile.firstName && form.elements.firstName) {
      form.elements.firstName.value = profile.firstName;
    }

    if (profile.lastName && form.elements.lastName) {
      form.elements.lastName.value = profile.lastName;
    }

    if (profile.birthDate && form.elements.birthDate) {
      form.elements.birthDate.value = profile.birthDate;
    }

    if (profile.gender) {
      var genderRadio = form.querySelector('[data-gender-key="' + profile.gender + '"]');

      if (genderRadio) {
        genderRadio.checked = true;
      }
    }

    if (typeof profile.acceptsMarketing === 'boolean' && form.elements.acceptsMarketing) {
      form.elements.acceptsMarketing.checked = profile.acceptsMarketing;
    }
  }

  async function loadProfileStatus(form) {
    var profileStatusEndpoint = form.getAttribute('data-profile-status-endpoint') || '';
    var accountUrl = form.getAttribute('data-account-url') || '/account';
    var email = resolveInitialEmail(form);
    var isPostOtpFlow = new URLSearchParams(window.location.search).get('post_otp') === '1';
    var hideCardWhileLoading = isPostOtpFlow;
    var shouldRedirect = false;

    if (!profileStatusEndpoint || !email) {
      if (isPostOtpFlow) {
        setProfileStatusLoading(form, false, true);
      }
      return;
    }

    setProfileStatusLoading(form, true, hideCardWhileLoading);

    try {
      var response = await fetch(profileStatusEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: email })
      });

      if (!response.ok) {
        return;
      }

      var profile = await response.json();

      if (!profile || !profile.exists) {
        return;
      }

      if (profile.profileCompleted && isPostOtpFlow) {
        shouldRedirect = true;

        if (form.hmLeaveGuard) {
          form.hmLeaveGuard.allowLeave = true;
        }

        window.location.replace(resolvePostCompletionRedirect(accountUrl));
        return;
      }

      applyProfileToForm(form, profile);
    } catch (e) {
      // Ignore profile preload failures; the form remains usable.
    } finally {
      if (!shouldRedirect) {
        setProfileStatusLoading(form, false, hideCardWhileLoading);
      }
    }
  }

  function collectPayload(form) {
    var prefilledEmail = resolveInitialEmail(form);
    var emailField = form.elements.email;
    var emailDisplay = form.querySelector('[data-email-display]');

    if (emailField && prefilledEmail) {
      emailField.value = prefilledEmail;
      persistEmailForFlow(prefilledEmail);
    }

    if (emailDisplay) {
      emailDisplay.textContent = normalizeEmail((emailField && emailField.value) || prefilledEmail);
    }

    var firstName = (form.elements.firstName.value || '').trim();
    var lastName = (form.elements.lastName.value || '').trim();

    return {
      email: normalizeEmail((emailField && emailField.value) || ''),
      firstName: firstName,
      lastName: lastName,
      fullName: [firstName, lastName].filter(Boolean).join(' ').trim(),
      birthDate: form.elements.birthDate.value || '',
      gender: form.elements.gender.value || '',
      acceptsMarketing: Boolean(form.elements.acceptsMarketing && form.elements.acceptsMarketing.checked)
    };
  }

  async function handleSubmit(event) {
    event.preventDefault();

    var form = event.currentTarget;

    // 初期値取得中や非ユーザー操作の submit を無視する。
    if (form.dataset.profileStatusLoading === 'true') {
      return;
    }

    if (!event.isTrusted) {
      return;
    }
    var i18n = window.hmProfileCompletionI18n || {};
    var apiEndpoint = form.getAttribute('data-api-endpoint') || '';
    var loginOtpUrl = form.getAttribute('data-login-otp-url') || '/account/login';
    var accountUrl = form.getAttribute('data-account-url') || '/account';
    var shopOrigin = form.getAttribute('data-shop-origin') || '';
    var enableMockSubmit = form.getAttribute('data-enable-mock-submit') === 'true';
    var isLoggedIn = form.getAttribute('data-customer-logged-in') === 'true';
    var returnTo = resolveReturnTo();

    // サーバー側は /profile の upsert。ログイン状態は送信後の遷移先(下部)だけに使う。
    var submitEndpoint = apiEndpoint;

    setFieldError(form, 'email', '');

    if (!validate(form, i18n)) {
      return;
    }

    var payload = collectPayload(form);
    if (!payload.email) {
      setFieldError(form, 'email', i18n.required);
      return;
    }
    payload.isLoggedIn = isLoggedIn;

    toggleSubmitting(form, true, i18n);

    try {
      if (!submitEndpoint && enableMockSubmit) {
        if (form.hmLeaveGuard) {
          form.hmLeaveGuard.allowLeave = true;
        }

        setFormStatus(form, 'success', i18n.mockSuccess);
        return;
      }

      if (!submitEndpoint) {
        setFormStatus(form, 'error', i18n.apiNotConfigured);
        return;
      }

      var response = await fetch(submitEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        var errorMessage = '';
        try {
          var errorData = await response.json();
          if (errorData) {
            if (typeof errorData.message === 'string') {
              errorMessage = errorData.message;
            } else if (errorData.error) {
              if (typeof errorData.error === 'string') {
                errorMessage = errorData.error;
              } else if (typeof errorData.error.message === 'string') {
                errorMessage = errorData.error.message;
              }
            }
          }
        } catch (e) {
          errorMessage = '';
        }
        throw new Error(errorMessage || 'request_failed');
      }

      var email = normalizeEmail(payload.email);
      if (email) {
        persistEmailForFlow(email);
      }

      if (form.hmLeaveGuard) {
        form.hmLeaveGuard.allowLeave = true;
      }

      if (isLoggedIn) {
        setFormStatus(form, 'success', i18n.updateSuccess || i18n.submitSuccess || '');
        window.location.href = resolvePostCompletionRedirect(accountUrl);
      } else {
        var profileCompletionPath = window.location.pathname;
        var otpReturnTo = returnTo;
        if (window.HmAccountReturnTo) {
          otpReturnTo = window.HmAccountReturnTo.buildPostOtpCompletionReturnTo(profileCompletionPath, returnTo);
        }
        window.location.href = buildLoginRedirectUrl(loginOtpUrl, email, shopOrigin, otpReturnTo);
      }
    } catch (error) {
      var message = (error && error.message && error.message !== 'request_failed') ? error.message : i18n.submitError;
      setFormStatus(form, 'error', message);
    } finally {
      toggleSubmitting(form, false, i18n);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    resolveReturnTo();

    var forms = document.querySelectorAll('[data-profile-completion-form]');

    forms.forEach(function (form) {
      form.hmLeaveGuard = setupLeaveGuard(form);
      collectPayload(form);
      loadProfileStatus(form);
      form.addEventListener('submit', handleSubmit);
    });
  });
})();
